module.exports = __webpack_public_path__ + "media/images/portal/logo-635726e0424628bbe871bc706448b49f.svg";